import * as React from 'react';

export default ({ color = '#B5BFD2', size = 24, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 1024 1024"
    aria-hidden="true"
    data-icon="play-circle"
    fill={color}
    {...rest}
  >
    <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64m0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372" />
    <path d="M424.4 360.8c-4.4-2.5-9.8 0.6-9.8 5.6v291.2c0 5 5.4 8.1 9.8 5.6l250.4-145.6c4.2-2.4 4.2-8.8 0-11.2z" />
  </svg>
);
